const prefix = 'address-input';

export const dataHooks = {
  loader: `${prefix}-loader`,
  noResultsText: `${prefix}-no-results-text`,
};

export const STATUS = {
  loading: 'loading',
  error: 'error',
  warning: 'warning',
} as const;

export const BORDER = {
  standard: 'standard',
  round: 'round',
  bottomLine: 'bottomLine',
  none: 'none',
} as const;

export const SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;
